import React from 'react';
import ImageGallery from '../components/ImageGallery';
import SEOHeadNative from '../components/SEOHeadNative';

const ElectriciteGenerale: React.FC = () => {
  const galleryImages = [
    {
      src: '/images/electricite/installation-tableau.jpg',
      title: 'Installation tableau électrique',
      description: 'Mise en place de tableaux électriques modernes et conformes aux normes'
    },
    {
      src: '/images/electricite/eclairage-led.jpg',
      title: 'Éclairage LED',
      description: 'Installation d\'éclairages LED économiques et performants'
    },
    {
      src: '/images/electricite/prises-interrupteurs.jpg',
      title: 'Prises et interrupteurs',
      description: 'Pose de prises et interrupteurs design et fonctionnels'
    },
    {
      src: '/images/electricite/renovation-electrique.jpg',
      title: 'Rénovation électrique',
      description: 'Mise aux normes complète d\'installations électriques anciennes'
    },
    {
      src: '/images/electricite/cablage-batiment.jpg',
      title: 'Câblage bâtiment',
      description: 'Réseaux électriques complets pour constructions neuves'
    },
    {
      src: '/images/electricite/domotique.jpg',
      title: 'Solutions domotiques',
      description: 'Maison connectée et automatisations intelligentes'
    }
  ];

  return (
    <div>
      <SEOHeadNative
        title="Électricité Générale - OZARKS ELEC"
        description="Électricien professionnel à Viesly. Installation électrique, mise aux normes, éclairage LED, domotique. Interventions dans l'Aisne, Thiérache, métropole lilloise et valenciennois."
        keywords="électricien Viesly, installation électrique Aisne, mise aux normes électriques, éclairage LED, domotique, tableau électrique Nord"
        canonical="/elecgnrle"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Électricité Générale",
          "description": "Installation électrique, mise aux normes, éclairage LED, domotique. Interventions dans l'Aisne, Thiérache, métropole lilloise et valenciennois.",
          "provider": {
            "@type": "ElectricalContractor",
            "name": "OZARKS ELEC",
            "url": "https://ozarkselec.com"
          },
          "areaServed": ["Aisne", "Thiérache", "Caudrésis", "Catésis", "Nord"],
          "serviceType": "Installation électrique"
        }}
      />
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark">
                Électricité <span className="ozarks-blue-medium">Générale</span>
              </h1>
              
              <div style={{marginTop: '60px', textAlign: 'left'}}>
                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>⚡ Installations électriques</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    De la construction neuve à la rénovation complète, nous réalisons toutes vos installations 
                    électriques en respectant scrupuleusement les normes NF C 15-100 en vigueur.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🔧 Mise aux normes</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Diagnostic et mise en conformité de vos installations électriques anciennes. 
                    Sécurisation complète avec remplacement des tableaux électriques et modernisation du réseau.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>💡 Éclairage et domotique</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Solutions d'éclairage LED performantes et économiques. Installations domotiques 
                    pour une maison connectée : pilotage à distance, programmation, économies d'énergie.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🚨 Dépannage et maintenance</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Intervention rapide pour tous vos dépannages électriques. Maintenance préventive 
                    et curative de vos installations pour garantir sécurité et fiabilité.
                  </p>
                </div>

                <div style={{backgroundColor: 'var(--ozarks-light-gray)', padding: '20px', borderRadius: '10px', marginTop: '40px'}}>
                  <h4 className="ozarks-blue-dark" style={{marginBottom: '15px'}}>🏆 Expertise reconnue</h4>
                  <p className="ozarks-gray" style={{lineHeight: '1.7', marginBottom: '0'}}>
                    <strong>Plus de 15 ans d'expérience</strong> dans l'électricité générale. 
                    Certifications à jour, garantie décennale et respect des délais d'intervention.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Galerie interactive de réalisations */}
      <div className="r t-rec t-rec_pt_60 t-rec_pb_60" style={{paddingTop: '60px', paddingBottom: '60px', backgroundColor: 'var(--ozarks-light-gray)'}}>
        <div className="t-container">
          <div className="t-col t-col_12">
            <div className="t-section__title t-title t-title_xs t-align_center t-margin_auto">
              <div style={{fontSize: '32px'}} className="ozarks-blue-dark">
                Galerie de nos <span className="ozarks-blue-medium">réalisations</span>
              </div>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginTop: '15px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Découvrez quelques-unes de nos réalisations en électricité générale. 
                Cliquez sur les images pour les voir en grand format.
              </div>
            </div>
            
            <ImageGallery images={galleryImages} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElectriciteGenerale;